import Vue from 'b2b-common/vue-config'
import axios from 'b2b-common/vue-config/axios'
import router from 'b2b-common/vue-config/router'
import './config/vee-validate'
import routes from './routes'
import App from './app.vue'

import '@/assets/scss/bootstrap-import.scss'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/server/' : 'https://b2bstaging.helloholidays.ro/server/'

router.addRoutes(routes)

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
